import React, { useEffect } from "react";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import { useDispatch, useSelector } from "react-redux";
import { ORG_ID, PAGE_SIZE, USER_ID } from "../../../../constant/constant";
import { useLocation } from "react-router-dom";
import SwViewStatementMapping from "../components/SwViewStatementMapping";

const SwViewStatementMappingContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const acknowledgment = location?.state?.acknowledgment;
  const defaultQuestionSetData = {
    organisationId: ORG_ID(),
    assetTypeId: "",
    SubClassId: "",
    certifyStatementId: acknowledgment?.key,
    isActive: true,
    page: 1,
    pageSize: PAGE_SIZE,
    search: "",
    allowPagination: true,
    userId: 0,
    status: "",
  };

  const questionSetList = useSelector((state) => state.swQuestionSetList);
  const questionSetListData = (data) => {
    dispatch(swInspectionAction.getSwQuestionSetList(data));
  };

  const showLoader = useSelector(
    (state) => state.swQuestionSetList?.isLoading
  );

  useEffect(() => {
    if (acknowledgment) {
      questionSetListData(defaultQuestionSetData);
    }
  }, [acknowledgment]);

  return (
    <>
      <SwViewStatementMapping
        questionSetList={questionSetList?.data?.listQuestionSetDetails}
        questionSetListData={questionSetListData}
        count={questionSetList?.data?.count}
        isLoading={showLoader}
        acknowledgment={acknowledgment}
      />
    </>
  );
};

export default SwViewStatementMappingContainer;
